import React from 'react';

import StatisticsContent from '../component-list-statistics';
import Suspense from '../../Common/components/Suspense-component';
import { getCurrentUser } from '../../Users/epics-users';

class StatisticsContainer extends React.Component {
    //constructor(props) {
      //  super(props);
        // console.log();
        // this.state = {
        //     orderBy: "names",
        //     orderDirection: 'asc',
        //     page: 0,
        //     limit: 30,
        // };
    //}

    render() {
        return (
            <Suspense
                apiCalls={{
                    currentUser: getCurrentUser
                }}
            >
                <StatisticsContent />
            </Suspense>
        );
    }
}

export default StatisticsContainer;



// WEBPACK FOOTER //
// ./src/customModules/Statistics/containers/container-list-statistics.js